module.exports = __webpack_public_path__ + "static/media/coffee-nov30-dt-en.f65b27e3.jpg";